import { render, staticRenderFns } from "./ApiTokens.vue?vue&type=template&id=5647a630&scoped=true"
import script from "./ApiTokens.vue?vue&type=script&lang=ts"
export * from "./ApiTokens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5647a630",
  null
  
)

export default component.exports